import './tarteaucitron'
//Bootstrap
$('.show_boot').click(function() {
    $('.grid_bootstrap').toggle();
})

import 'jquery-validation/'
import 'jquery-validation/dist/localization/messages_fr'
jQuery.validator.addMethod("phone", function (value, element) {
    if ( /^\d{3}-?\d{3}-?\d{4}$/g.test(value)) {
        return true;
    } else if (value == "") {
        return true;
    } else {
        return false;
    }
}, "Téléphone non valide");

// import 'bootstrap/js/src/collapse'
// import 'bootstrap/js/src/alert'
// import 'bootstrap/js/src/modal'

//Slick
// import 'slick-carousel/slick/slick'
// import 'slick-carousel/slick/slick.scss'
// import 'slick-carousel/slick/slick-theme.scss'
import $ from 'jquery'

//ANIMTION ON SCROLL TRIGGER for Jquery
$.fn.visible = function(partial) {
    var $t            = $(this),
        $w            = $(window),
        viewTop       = $w.scrollTop(),
        viewBottom    = viewTop + $w.height(),
        _top          = $t.offset().top,
        _bottom       = _top + $t.height(),
        compareTop    = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
};


$.fn.wordCounter = () => {
    let html = $(this).innerHTML;
    //
    // var rx = <\s*script[^>]*>(.*?)<\s*/\s*script>; // for script tag
    var arr = rx.exec("<script type='text/javascript'>let sdf = dsf;</script>");
    // console.log(arr)

    let text = $('#elementId').text();
    let charsLength = text.length;
    let wordsCount = text.split(' ').length;

    let wordsPerMinute = 230;

    return wordsCount;
}
